/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_No_ResumeInputs */

const en_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a resume to apply suggestions`)
};

const de_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen Lebenslauf, um Vorschläge anzuwenden`)
};

const fr_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un CV pour appliquer les suggestions`)
};

const es_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona un currículum para aplicar sugerencias`)
};

const it_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un CV per applicare i suggerimenti`)
};

const nl_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecteer een CV om suggesties toe te passen`)
};

const pl_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz CV, aby zastosować sugestie`)
};

const fi_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valitse ansioluettelo ehdotusten soveltamiseksi`)
};

const da_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vælg et CV for at anvende forslag`)
};

const sv_keyword_optimizer_toast_no_resume = /** @type {(inputs: Keyword_Optimizer_Toast_No_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Välj ett CV för att tillämpa förslag`)
};

/**
* | output |
* | --- |
* | "Select a resume to apply suggestions" |
*
* @param {Keyword_Optimizer_Toast_No_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_no_resume = /** @type {((inputs?: Keyword_Optimizer_Toast_No_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_No_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_no_resume(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_no_resume(inputs)
	return en_keyword_optimizer_toast_no_resume(inputs)
});